/**
 * Without the following the only export is `default`
 */
module.exports = require('./index').default
